<div class="w-full mb-6">
  <split-group-card [label]="'Ganhos e Saldos'">
    <div class="grid">
      <div class="col">
        <split-report-message [tooltipMessage]="tooltipPreviousBalance" [width]="'auto'" [value]="+form.value.previousBalance!" [label]="'Saldo anterior'"
            [bgColor]="'#00336614'" [borderColor]="'#003366'"  [disableBorder]="true"></split-report-message>
         <ng-template #tooltipPreviousBalance> 
            <p class="my-1">Representa o valor remanescente do período anterior.</p>
            <ul class="pl-3">
              <li>Zero: você recebeu todo o ganho projetado.</li>
              <li>Negativo: você recebeu um adiantamento (valor acima do projetado).</li>
              <li>Positivo: parte do seu ganho não foi repassada no período anterior.</li>
            </ul>
         </ng-template>
        </div>
        <div class="col">
          <split-report-message [tooltipMessage]="tooltipTotal" [width]="'auto'" [value]="+form.value.total!" [label]="'Ganho projetado (sem taxas)'"
            [bgColor]="'#16901614'" [borderColor]="'#169016'" [disableBorder]="true"></split-report-message>
          <ng-template #tooltipTotal> 
            <p class="my-1">Previsão total de comissões no período selecionado.</p>
            <p class="my-1">Valor calculado pela soma das comissões acordadas sobre cada atendimento realizado, antes de deduções ou repasses.</p>
         </ng-template>
        </div>
        <div class="col">
          <split-report-message [tooltipMessage]="tooltipBalance" [width]="'auto'" [value]="+form.value.balance!" [label]="'Saldo acumulado a receber'"
              [bgColor]="'#00336614'" [borderColor]="'#003366'" [disableBorder]="true"></split-report-message>
          <ng-template #tooltipBalance> 
            <p class="my-1">Valor total disponível para repasse.</p>
            <p class="my-1">Resultado da fórmula:</p>
            <i>(Saldo Inicial) + (Ganho Projetado) - (Repasses Realizados)</i>
            <p class="my-1">Inclui ajustes do mês anterior e movimentações atuais.</p>
          </ng-template>
        </div>
    </div>
  </split-group-card>

  <split-group-card [label]="'Repasses'">
    <div class="grid">
      <div class="col">
        <split-report-message [tooltipMessage]="tooltipAmount" [width]="'auto'" [value]="+form.value.dinheiro!" [label]="'Repasse em dinheiro'"
          [bgColor]="'#004AA014'" [borderColor]="'#004AA0'" [disableBorder]="true"></split-report-message>
        <ng-template #tooltipAmount> 
          <p class="my-1">Pagamento físico (cédulas) pela Unidade.</p>
          <ul class="pl-3">
            <li>Comissão parcial ou total entregue manualmente.</li>
            <li>Registro apenas para controle: não utiliza o sistema Splitpay.</li>
          </ul>
        </ng-template>
      </div>
      <div class="col">
        <split-report-message [tooltipMessage]="tooltipSplit" [width]="'auto'" [value]="+form.value.split!" 
          [label]="'Repasse por split de pagamento'"
          [bgColor]="'#004AA014'" [borderColor]="'#004AA0'" [disableBorder]="true">
        </split-report-message>
        <ng-template #tooltipSplit> 
          <p class="my-1">Comissão via plataforma digital (cartão/Pix).</p>
          <p class="my-1">Valores reservados automaticamente pelo Splitpay:</p>
          <ul class="pl-3">
            <li>Disponíveis para saque após processamento (1-3 dias úteis).</li>
            <li>Vinculado diretamente às transações dos clientes.</li>
          </ul>
        </ng-template>
      </div>
      <div class="col">
        <split-report-message [tooltipMessage]="tooltipBank" [width]="'auto'" [value]="+form.value.banco!" 
          [label]="'Repasse por transferência bancária'"
          [bgColor]="'#004AA014'" [borderColor]="'#004AA0'" [disableBorder]="true">
        </split-report-message>
        <ng-template #tooltipBank> 
          <p class="my-1">Pagamento eletrônico (TED/DOC/Pix) pela Unidade.</p>
          <ul class="pl-3">
            <li>Comissão parcial ou total depositada em sua conta.</li>
            <li>Registro apenas para controle: não utiliza o sistema Splitpay.</li>
          </ul>
        </ng-template>
      </div>
    </div>
 </split-group-card>

  <split-select-button
            (onOptionClick)="setAppointmentTypeFilter($event)"
            [options]="optionsReport"
          ></split-select-button>

  <div class="scroll_container table mt-3">
    <div class="gradient"></div>
    <div *ngIf="!showList" class="flex align-items-center justify-content-center" [style.height]="'306px'">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
    <split-table *ngIf="showList && selectedOption.value == 1" [paginator]="true" [totalRecords]="totalPageProfessionalList" (pageChange)="pageChangeProfessionalList($event)" card-body [checklist]="false" [widthColumns]="[10, 10, 15, 15, 15, 10, 10, 10, 10]"
      [dados]="professionalData!" theme="tertiary">
      <ng-template #header>
        <div class="text-center w-full">Id Receita</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        {{item.id}}
      </ng-template>
      <ng-template #header>
        <div class="text-center w-full">Data</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="primary text-center w-full">
          {{ item.date }}
        </div>
      </ng-template>

      <ng-template #header> Pagador </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <split-truncate-text width="230px"
        [text]="item.payerName"></split-truncate-text>
      </ng-template>

      <ng-template #header> Unidade </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="add_ellipsis">{{item.unitName}}</div>
      </ng-template>

      <ng-template #header> Serviço </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="add_ellipsis">
          {{ item.serviceName }}
        </div>
      </ng-template>

      <ng-template #header> Forma de Pagamento </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="add_ellipsis">{{item.paymentMethod}}</div>
      </ng-template>

      <ng-template #header> 
        <div class="flex gap-2 align-items-center justify-content-center">
          <span>
            Valor cobrado
          </span>
        </div>
        </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        {{ item.totalAmount | currency:'BRL':'symbol':'1.2-2' }}
      </ng-template>

      <ng-template #header> Ganho projetado profissonal </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        {{ item.estimatedProfessionalAmount | currency:'BRL':'symbol':'1.2-2' }}
      </ng-template>
    </split-table>

    <split-table *ngIf="showList && selectedOption.value == 2" [paginator]="true" [totalRecords]="totalPageProfessionalRepost" (pageChange)="pageChangeProfessionalRepost($event)" card-body [checklist]="false" [widthColumns]="[10, 10, 15, 15, 10, 10, 10, 10]"
    [dados]="listRepost!" theme="tertiary">
    <ng-template #header>
      <div class="text-center w-full">Id Despesa</div>
    </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      {{item.id}}
    </ng-template>
    <ng-template #header>
      <div class="text-center w-full">Data</div>
    </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      <div class="primary text-center w-full">
        {{ item.date | date: "dd/MM/yyyy" }}
      </div>
    </ng-template>

    <ng-template #header> Unidade </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      <div class="add_ellipsis">{{item.unitName}}</div>
    </ng-template>

     <ng-template #header> Serviços </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      <div class="add_ellipsis">{{item.serviceName}}</div>
    </ng-template>

    <ng-template #header> Forma de Pagamento </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      <div class="add_ellipsis">{{item.paymentMethod}}</div>
    </ng-template>

    <ng-template #header> Valor cobrado</ng-template>
    <ng-template #coluna let-item="dadosLinha">
      {{ (item.paymentAmount | currency:'BRL':'symbol':'1.2-2') || '-' }}
    </ng-template>

    <ng-template #header> Forma de repasse </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      <div class="add_ellipsis">{{item.transferMethod}}</div>
    </ng-template>

    <ng-template #header> Split </ng-template>
    <ng-template #coluna let-item="dadosLinha">
      {{ item.effectiveProfessionalAmount | currency:'BRL':'symbol':'1.2-2' }}
    </ng-template>
  </split-table>
  </div>
</div>